import type { RouteObject } from 'react-router';

import { createPaths } from '@ricoh/ria.client.core/utils/router/path';

/** Error route. */
const errorRoute: RouteObject = {
  path: 'error',
  lazy: async () => (await import('~/components/layout/error')).default,

  children: [
    // Error 500
    {
      path: '',
      index: true,
      lazy: async () => (await import('~/components/page/error/500')).default,
    },

    // Error 503
    {
      path: 'service-unavailable',
      lazy: async () => (await import('~/components/page/error/503')).default,
    },

    // Error 401
    {
      path: 'unauthorized',
      lazy: async () => (await import('~/components/page/error/401')).default,
    },

    // Error 403
    {
      path: 'access-denied',
      lazy: async () => (await import('~/components/page/error/403')).default,
    },

    // Error 404
    {
      path: 'not-found',
      lazy: async () => (await import('~/components/page/error/404')).default,
    },
  ],
};

/** Error paths. */
export const errorPaths = createPaths(errorRoute);

export default errorRoute;
